import React from 'react';

class LoadingScreen extends React.Component {
    render() {
        return (
            <div className="loading-screen">
                <i className="loading-screen__icon fas fa-circle-notch fa-spin"></i>
                <h2 className="loading-screen__title w-full text-center">
                    {this.props.title}
                </h2>
                <div className="loading-screen__content w-full text-center">
                    {this.props.content}
                </div>
            </div>
        )
    }
}

export default LoadingScreen;


// WEBPACK FOOTER //
// ./scripts/components/LoadingScreen.jsx